export { default } from './format-y-axis-tick'
